<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-order">
    <mat-card-header>

    </mat-card-header>
    <mat-card-content>

        <ng-container *ngIf="this.doNotDisplay === false">

        <ng-container *ngIf="this.isProcessing === true">
            <div class="d-flex justify-content-center" style="margin-top:20px;margin-bottom:20px;">
                    <span style="font-size:24px;font-weight:bold">Please stand by while we update the Additional Credentials...</span>
            </div>
        </ng-container>

        <ng-container *ngIf="this.isProcessing === false">
            <span style="margin-left: 0px;margin-top:20px;"  class="lanai-page-title">Add Additional Credential</span>
        <form
        (ngSubmit)="onSubmitAddNewCredential()"
        novalidate
        [formGroup]="credentialForm"

        style="margin-top:20px;">
        <div class="row margin-top:20px;">
            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label>Credential Type</mat-label>
                    <mat-select matNativeControl formControlName="credentialTypeId">
                      <mat-option value="">Select Credential Type</mat-option>
                      <mat-option *ngFor="let credentialType of this._appGeneralState.credentialTypeListForCurrentLotNumber" [value]="credentialType.credentialTypeId">
                        {{credentialType.credentialTypeName}}
                      </mat-option>
                    </mat-select>
                    <mat-error>The credential type is required</mat-error>
                </mat-form-field>
            </div>

            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label>Credential Value</mat-label>
                    <input matInput placeholder="Credential Value" maxlength="100" formControlName="credentialValue"
                        (keypress)="keyPressCardNumber($event)" autocomplete="chrome-off"  >
                    <mat-error>The credential value is required</mat-error>
                </mat-form-field>
            </div>
        </div>

        <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!credentialForm.valid">Submit</button>
        <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="onResetAdditionalCredentialData()">Clear</button>
        </form>
    </ng-container>
        <div style="margin-top:20px;"></div>


<ng-container *ngIf="additionalCredentials.length > 0 && this.isProcessing === false">

    <igx-grid  [batchEditing]="true" #gridProfile [data]="this.additionalCredentials" [width]="'99%'" [height]="'400px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:20px;
    paste-handler  [primaryKey]="'additionalCredentialId'" [rowEditable]="false"
    [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact"
    [emptyGridMessage]="'No Additional Credentials for Parker'" >


    <igx-column field="" header=" " [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true">
        <ng-template #compositeTemp igxCell let-cell="cell">
            <button mat-icon-button aria-label="Delete Credential" (click)="onDeleteCredential(cell.row.data.additionalCredentialId)" matTooltip="Delete Credential" style="margin-left:20px;">
                <mat-icon>delete</mat-icon>
            </button>
        </ng-template>
    </igx-column>

    <igx-column field="credentialTypeName" header="Credential Type" [sortable]="true" width="250px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="credentialValue" header="Credential Value" [sortable]="true" width="250px" required style="font-size:10px;"  [resizable]="true"></igx-column>

  <igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

    </igx-grid>

</ng-container>

</ng-container>
<ng-container *ngIf="this.doNotDisplay">
    <h4>Coming Soon!</h4>
</ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    <hr />

  </mat-card-actions>



</mat-card>
